<template>
  <div class="tw-border tw-border-neutral-300 tw-rounded-xl tw-p-5 tw-flex tw-gap-x-6 tw-items-center tw-animate-pulse">
    <div class="tw-relative tw-self-center">
      <div class="tw-w-[120px] tw-h-[80px] tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-rounded-lg tw-animate-shimmer tw-bg-[length:200%_100%]" />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-y-3 tw-w-full">
      <div class="tw-flex tw-justify-between tw-gap-2.5">
        <div class="tw-w-3/4 tw-h-6 tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-rounded tw-animate-shimmer tw-bg-[length:200%_100%]" />
        <div class="tw-w-5 tw-h-5 tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-rounded-full tw-animate-shimmer tw-bg-[length:200%_100%] tw-shrink-0" />
      </div>

      <div class="tw-w-1/2 tw-h-5 tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-rounded tw-animate-shimmer tw-bg-[length:200%_100%]" />
    </div>
  </div>
</template>
